import gsap from "gsap";

const initMap = () => {
  const map = <SVGElement | null>document.querySelector(".map");

  if (!(map instanceof Element)) {
    return;
  }

  /**
   * Dynamicall set viewBox bounds based on window width.
   */
  const updateViewBox = () =>
    map.setAttribute(
      "viewBox",
      window.innerWidth >= 1024 ? "0 0 3000 1400" : "1000 0 1400 1400"
    );

  window.addEventListener("resize", updateViewBox);
  updateViewBox();

  const neighbourhoods = [
    ...map.querySelectorAll<SVGGElement>(".map__neighbourhood"),
  ];

  /**
   * The text bounce timeline.
   */
  const buildTextTimeline = (neighbourhood: Element) => {
    const response = gsap.timeline({
      paused: true,
    });

    response.to(neighbourhood.querySelector(".map__text"), {
      y: -5,
    });

    return response;
  };

  /**
   * The pole bounce timeline.
   */
  const buildPoleTimeline = (neighbourhood: Element) => {
    const response = gsap.timeline({
      paused: true,
    });

    response.to(neighbourhood.querySelector(".map__pole"), {
      y: -5,
    });

    return response;
  };

  /**
   * The area/border fade in timeline.
   */
  const buildAreaTimeline = (neighbourhood: Element) => {
    const response = gsap.timeline({
      paused: true,
    });

    const areas = neighbourhood.querySelectorAll(".map__area");

    response.to(
      areas,
      {
        opacity: 0.4,
      },
      "area"
    );

    response.to(
      neighbourhood.querySelectorAll(".map__border"),
      {
        opacity: 1,
      },
      "area"
    );

    return response;
  };

  /**
   * Setup mouse events for neighbourhoods.
   */
  neighbourhoods.map((neighbourhood) => {
    const dummy = neighbourhood.querySelector(".map__dummy");

    const textTimeline = buildTextTimeline(neighbourhood);
    const poleTimeline = buildPoleTimeline(neighbourhood);
    const areaTimeline = buildAreaTimeline(neighbourhood);

    dummy?.addEventListener("mouseenter", () => {
      textTimeline.play(0);
      poleTimeline.play(0);
      areaTimeline.play();
    });

    dummy?.addEventListener("mouseleave", () => {
      textTimeline.reverse();
      poleTimeline.reverse();
      areaTimeline.reverse();
    });
  });
};

export default initMap();
